// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rufflet: PokeData = {
  "id": 627,
  "name": "rufflet",
  "height": 5,
  "weight": 105,
  "base_experience": 70,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "whirlwind",
    "fury-attack",
    "thrash",
    "double-edge",
    "leer",
    "peck",
    "quick-attack",
    "slash",
    "scary-face",
    "twister",
    "crush-claw",
    "aerial-ace",
    "roost",
    "tailwind",
    "air-slash",
    "brave-bird",
    "defog",
    "hone-claws",
    "sky-drop"
  ],
  "moves": [
    "leer",
    "peck",
    "quick-attack",
    "scary-face",
    "aerial-ace",
    "roost",
    "tailwind",
    "air-slash",
    "brave-bird",
    "tackle",
    "chatter",
    "refresh",
    "purification"
  ],
  "evolution_chain": {
    "id": 319,
    "item": null,
    "species": [
      {
        "name": "rufflet",
        "order": 628,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "braviary",
        "order": 629,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 627,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 54,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 60,
    "ability_power": 83
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
